<template>
    <notification-item
        title="Pozvánka do týmu"
        :created="data.created"
        :author="data.payload.teamName"
        avatar="/img/myteam/Team-Crest.png"
        :link="{ name: 'teamDetail', params: { id: data.payload.teamId } }"
    >
        <p>Majitel týmu <span class="semibold semibold--textgreen"><router-link :to="{ name: 'teamDetail', params: { id: data.payload.teamId } }">{{ data.payload.teamName }}</router-link></span> vám posílá pozvánku do svého týmu.</p>
        <p>Pozvánku můžete přijmout nebo odmítnout.</p>

        <template v-slot:actions>
            <div class="news-notification__button">
                <v-btn
                    color="primary" dark
                    @click.prevent="accept"
                    :loading="accepting"
                    :disabled="declining"
                >
                    <v-icon left>mdi-check</v-icon> Přijmout
                </v-btn>
            </div>
            <div class="news-notification__button">
                <v-btn
                    color="primary" dark
                    @click.prevent="decline"
                    :loading="declining"
                    :disabled="accepting"
                >
                    <v-icon left>mdi-cancel</v-icon> Odmítnout
                </v-btn>
            </div>
        </template>
    </notification-item>
</template>

<script>
    import NotificationMixin from '../NotificationMixin';
    import {
        ACCEPT_INVITATION_REQUEST,
        DECLINE_INVITATION_REQUEST,
    } from '../../../store/actions/team';

    export default {
        name: 'TeamInvitation',
        mixins: [NotificationMixin],
        data () {
            return {
                accepting: false,
                declining: false,
            };
        },
        computed: {
            requestId () {
                return this.data.payload.requestId;
            },
        },
        methods: {
            async accept () {
                try {
                    this.accepting = true;
                    await this.$store.dispatch('team/' + ACCEPT_INVITATION_REQUEST, {
                        requestId: this.requestId,
                        teamId: this.data.payload.teamId,
                        teamName: this.data.payload.teamName,
                    });
                    this.$toast.success('Pozvánka byla přijata.');
                    this.hide();
                } catch (e) {
                    const message = e.response.data.message || 'Při přijetí pozvánky došlo k chybě. Zkuste to později.';
                    this.$toast.error(message);
                } finally {
                    this.accepting = false;
                }
            },
            async decline () {
                try {
                    this.declining = true;
                    await this.$store.dispatch('team/' + DECLINE_INVITATION_REQUEST, { requestId: this.requestId });
                    this.$toast.success('Pozvánka byla odmítnuta.');
                    this.hide();
                } catch (e) {
                    this.$toast.error('Při odmítnutí pozvánky došlo k chybě. Zkuste to později.');
                } finally {
                    this.declining = false;
                }
            },
        },
    }
</script>
